module.exports = __webpack_public_path__ + "img/lights.7460748b.jpeg";